import initialState from './state';

import {
  PENDING_STATUS,
  UNDEFINED_STATUS
} from './action-status';

import {
  RESET_STATE,
  SET_STORAGE_SPACE,
  SET_SETUP_PASSWORD_STATUS,
  SET_ARCHIVE_DELETION_STATUS,
  SET_CONTENT_ITEMS,
  SET_FETCH_STORAGE_SPACE_STATUS,
  SET_FETCH_CONTENT_ITEMS_STATUS,
  SET_ACTIVE_CONTENT_TYPE,
  SET_APP_FEATURES,
  SET_FILE_VERSIONS,
  SET_FETCH_FILE_VERSIONS_STATUS,
  SET_SIGN_FILE_LINK,
  SET_SIGN_FILE_STATUS,
  SET_SEARCH_ENABLED_SATE,
  SET_SEARCH_RESULT_RECEIVED,
  SET_ACTIVE_VERSION_PATH,
  SET_ACTIVE_VOLUME_PATH,
  SET_ACTIVE_FOLDER_ITEM,
  SET_FETCH_CONTAINER_ITEMS_STATUS,
  SET_MACHINES,
  SET_BACKUPS,
  SET_INCOMPLETE_BACKUPS,
  SET_INCOMPLETE_BACKUPS_COUNT,
  SET_INCOMPLETE_BACKUPS_SIZE,
  SET_TOTAL_USED_SPACE,
  SET_ACTIVE_MACHINE_ID,
  SET_ACTIVE_MACHINE_DISPLAY_NAME,
  SET_FETCH_BACKUPS_STATUS,
  SET_ACTIVE_BACKUP_ID,
  SET_ACTIVE_BACKUP_DISPLAY_NAME,
  SET_DELETE_ALL_INCOMPLETE_STATUS,
  SET_DISPLAY_USER_NAME
} from './mutation-types';

function isNeedChangeStatus(status, newStatus) {
  if (status === UNDEFINED_STATUS) {
    return newStatus === PENDING_STATUS;
  }
  return true;
}

export default {
  [RESET_STATE](state) {
    Object.assign(state, initialState());
  },
  [SET_STORAGE_SPACE](state, storageSpace) {
    state.storageSpace = storageSpace;
  },
  [SET_SETUP_PASSWORD_STATUS](state, status) {
    if (isNeedChangeStatus(state.setupArchivePasswordStatus, status)) {
      state.setupArchivePasswordStatus = status;
    }
  },
  [SET_ARCHIVE_DELETION_STATUS](state, status) {
    if (isNeedChangeStatus(state.archiveDeletionStatus, status)) {
      state.archiveDeletionStatus = status;
    }
  },
  [SET_CONTENT_ITEMS](state, contentItem) {
    state.contentItems = contentItem;
  },
  [SET_FETCH_STORAGE_SPACE_STATUS](state, status) {
    if (isNeedChangeStatus(state.fetchStorageSpaceStatus, status)) {
      state.fetchStorageSpaceStatus = status;
    }
  },
  [SET_FETCH_CONTENT_ITEMS_STATUS](state, status) {
    if (isNeedChangeStatus(state.fetchContentItemsStatus, status)) {
      state.fetchContentItemsStatus = status;
    }
  },
  [SET_ACTIVE_CONTENT_TYPE](state, activeContentType) {
    state.activeContentType = activeContentType;
  },
  [SET_APP_FEATURES](state, appFeatures) {
    state.appFeatures = appFeatures;
  },
  [SET_FILE_VERSIONS](state, fileVersions) {
    state.fileVersions = fileVersions;
  },
  [SET_FETCH_FILE_VERSIONS_STATUS](state, status) {
    if (isNeedChangeStatus(state.fetchFileVersionsStatus, status)) {
      state.fetchFileVersionsStatus = status;
    }
  },
  [SET_SIGN_FILE_LINK](state, signFileLink) {
    state.signFileLink = signFileLink;
  },
  [SET_SIGN_FILE_STATUS](state, status) {
    if (isNeedChangeStatus(state.signFileStatus, status)) {
      state.signFileStatus = status;
    }
  },
  [SET_SEARCH_ENABLED_SATE](state, searchEnabled) {
    state.searchEnabled = searchEnabled;
  },
  [SET_SEARCH_RESULT_RECEIVED](state, searchResultReceived) {
    state.searchResultReceived = searchResultReceived;
  },
  [SET_ACTIVE_VERSION_PATH](state, activeVersionPath) {
    state.activeVersionPath = activeVersionPath;
  },
  [SET_ACTIVE_VOLUME_PATH](state, activeVolumePath) {
    state.activeVolumePath = activeVolumePath;
  },
  [SET_ACTIVE_FOLDER_ITEM](state, activeFolderItem) {
    state.activeFolderItem = activeFolderItem;
  },
  [SET_FETCH_CONTAINER_ITEMS_STATUS](state, status) {
    if (isNeedChangeStatus(state.fetchContainerItemsStatus, status)) {
      state.fetchContainerItemsStatus = status;
    }
  },
  [SET_MACHINES](state, machines) {
    state.machines = machines;
  },
  [SET_BACKUPS](state, backups) {
    state.backups = backups;
  },
  [SET_INCOMPLETE_BACKUPS](state, incompleteBackups) {
    state.incompleteBackups = incompleteBackups;
  },
  [SET_INCOMPLETE_BACKUPS_COUNT](state, incompleteBackupsCount) {
    state.incompleteBackupsCount = incompleteBackupsCount;
  },
  [SET_INCOMPLETE_BACKUPS_SIZE](state, incompleteBackupsSize) {
    state.incompleteBackupsSize = incompleteBackupsSize;
  },
  [SET_TOTAL_USED_SPACE](state, totalUsedSpace) {
    state.totalUsedSpace = totalUsedSpace;
  },
  [SET_ACTIVE_MACHINE_ID](state, activeMachineId) {
    state.activeMachineId = activeMachineId;
  },
  [SET_ACTIVE_MACHINE_DISPLAY_NAME](state, activeMachineDisplayName) {
    state.activeMachineDisplayName = activeMachineDisplayName;
  },
  [SET_FETCH_BACKUPS_STATUS](state, status) {
    if (isNeedChangeStatus(state.fetchBackupsStatus, status)) {
      state.fetchBackupsStatus = status;
    }
  },
  [SET_ACTIVE_BACKUP_ID](state, activeBackupId) {
    state.activeBackupId = activeBackupId;
  },
  [SET_ACTIVE_BACKUP_DISPLAY_NAME](state, activeBackupDisplayName) {
    state.activeBackupDisplayName = activeBackupDisplayName;
  },
  [SET_DELETE_ALL_INCOMPLETE_STATUS](state, status) {
    if (isNeedChangeStatus(state.deleteAllIncompleteStatus, status)) {
      state.deleteAllIncompleteStatus = status;
    }
  },
  [SET_DISPLAY_USER_NAME](state, displayUserName) {
    state.displayUserName = displayUserName;
  }
};

